import { InjectionToken } from '@angular/core';

export const NB_TREE_GRID = new InjectionToken('NB_TREE_GRID');
